namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogExportCertifikacniAutorita extends GContentBase {
        private formElName: JQuery<HTMLElement>;
        private formElDownloadFile: JQuery<HTMLElement>;
        private fileContent: string;
        private fileType: string;
        private defaultName: string;

        private srv() {
            return this.createServiceContent("Gordic.Adm.WebControls.DialogExportCertifikacniAutorita")
        }

        onClose() {
            var file = this.element.findFields("fileCertificate").gfield("getValue")
            if (file.length > 0)
                this.srv().fire("ClearFile", { guid: file[0].guid })
        }

        downloadCertificate() {
            var downloadFile = $(".formDownloadCertificate").find(".gfilefield")
            downloadFile.find("span.fa-cloud-download").click();
        }

        exportCertificate() {
            if (this.formElName.gform("isValid")) {
                var fileName = "{0}{1}".format(this.formElName.findFields("fileName").gfield("getValue"), this.formElName.findFields("fileExtension").gfield("getValue"))
                this.beginOperation();
                this.srv().call("ExportCertificate", { fileContent: this.fileContent, fileName: fileName }).done((o) => {
                    this.actions.actDownloadFile?.update({ visible: true });
                    this.actions.actExportSpisPlan?.update({ visible: false });
                    this.formElDownloadFile.show();
                    this.formElName.hide();
                    this.formElDownloadFile.findFields("fileCertificate").gfield("setValue", o);
                }).fail(() => {
                    $.content($("#main")).notification("add", {
                        state: "error",
                        shortTemplate: "<b>jres:29809454</b><br /><span>jres:33000049</span>", //RC 33000049 : Chyba přii exportu certifikátu.
                        content: {},
                        icon: "fa-exclamation-circle"
                    }, true)
                }).always(() => {
                    this.endOperation();
                })
            }
        }

        onContentReady() {
            this.init();
        }

        private init() {
            this.createFormName();
            this.createFormDownloadFile();
            this.formElDownloadFile.hide();
            this.actions.actDownloadFile?.update({ visible: false })
        }

        private createFormName() {
            var formName = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1", name: "formExportCertificate" })
                .addRow("jres:33000023").addField("gstringbox", "w-8", {
                    name: "fileName",
                    initialValue: this.defaultName,
                }).addField("gstringbox", "w-4", {
                    name: "fileExtension",
                    initialValue: ".{0}".format(this.fileType),
                    disabled: true,
                    validators: [new Gordic.Validators.Required({ stopping: true })] 
                })

            this.formElName = $("<div>").appendTo(this.element).gform("createFrom", formName);
        }

        private createFormDownloadFile() {
            var formDownloadfile = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1", name: "formDownloadCertificate" })
                .addRow("jres:33000030").addField("gfilefield", {
                    name: "fileCertificate",
                    canUpload: false,
                    itemDeletable: false
                })

            this.formElDownloadFile = $("<div class='formDownloadCertificate'>").appendTo(this.element).gform("createFrom", formDownloadfile);
        }
    }
}